import { AxiosInstance } from 'axios';
import {
    PaymentsToClientsFilter,
    PaymentsToClientsTable,
    PaymentToClientInfo,
} from 'models/api/paymentsToClients';
import ResTable from 'models/api/table';
import { Key } from 'react';

const url = '/paymentstoclients';

export const getPaymentsToClientsList = async (
    axios: AxiosInstance,
    params?: PaymentsToClientsFilter
) => {
    const response = await axios.get<ResTable<PaymentsToClientsTable>>(url, {
        params: { ...params },
    });
    return response.data;
};

export const getPaymentsToClientsExcel = async (
    axios: AxiosInstance,
    params?: PaymentsToClientsFilter
) => {
    const { data } = await axios.get<Blob>('/payments/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const getPaymentToClient = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<PaymentToClientInfo>(`${url}/${id}`);
    return response.data;
};

export const repeatPayment = async (axios: AxiosInstance, id: Key) => {
    const response = await axios.post(`${url}/repeatPayment/${id}`);
    return response.data;
};
